import { User } from './user.model';

export const displayUserNameAndEmail = (user: User): string =>
  user ? `${user.firstName} ${user.lastName} (${user.email})` : '';
